export const FIELDS = {
  COMMON_LISTING: [
    {
      field: 'sku',
      type: 'String/200 (case insensitive)',
      required: true,
      translationKey: 'exampleSku',
    },
    {
      field: 'quantity',
      type: 'Int',
      required: true,
      translationKey: 'exampleQuantity',
    },
    {
      field: 'price',
      type: 'Decimal',
      required: true,
      translationKey: 'examplePrice',
    },
    {
      field: 'grade',
      type: 'Enum (Int)',
      required: true,
      translationKey: 'exampleState',
      allowedValues: 'PREMIUM,EXCELLENT,VERY_GOOD,GOOD,FAIR,STALLONE',
    },
    {
      field: 'currency',
      type: 'String/10',
      required: false,
      translationKey: 'exampleCurrency',
    },
    {
      field: 'shipper_1',
      type: 'Enum (String)',
      required: false,
      translationKey: 'exampleShipper1',
    },
    {
      field: 'shipping_price_1',
      type: 'Decimal',
      required: false,
      translationKey: 'exampleShippingPrice1',
    },
    {
      field: 'shipping_delay_1',
      type: 'Int',
      required: false,
      translationKey: 'exampleShippingDelay1',
    },
    {
      field: 'shipper_2',
      type: 'Enum (String)',
      required: false,
      translationKey: 'exampleShipper2',
    },
    {
      field: 'shipping_price_2',
      type: 'Decimal',
      required: false,
      translationKey: 'exampleShippingPrice2',
    },
    {
      field: 'shipping_delay_2',
      type: 'Int',
      required: false,
      translationKey: 'exampleShippingDelay2',
    },
    {
      field: 'shipper_3',
      type: 'Enum (String)',
      required: false,
      translationKey: 'exampleShipper3',
    },
    {
      field: 'shipping_price_3',
      type: 'Decimal',
      required: false,
      translationKey: 'exampleShippingPrice3',
    },
    {
      field: 'shipping_delay_3',
      type: 'Int',
      required: false,
      translationKey: 'exampleShippingDelay3',
    },
    {
      field: 'new_battery',
      type: 'Bool',
      required: false,
      translationKey: 'exampleNewBattery',
    },
    {
      field: 'min_price',
      type: 'Decimal',
      required: false,
      translationKey: 'exampleMinPrice',
    },
    {
      field: 'backpricer',
      type: 'Bool',
      required: false,
      translationKey: 'exampleBackpricer',
    },
  ],
  COMMON_PRODUCT: [
    {
      field: 'category_id',
      type: 'Int',
      required: true,
    },
    {
      field: 'title',
      type: 'String/200',
      required: true,
      translationKey: 'exampleTitle',
    },
    {
      field: 'description',
      type: 'Text',
      required: true,
      translationKey: 'exampleDescription',
    },
    {
      field: 'brand',
      type: 'String/100',
      required: true,
      translationKey: 'exampleBrand',
    },
    {
      field: 'price_new',
      type: 'Decimal',
      required: true,
      translationKey: 'examplePriceNew',
    },
    {
      field: 'weight',
      type: 'Int > 1',
      required: true,
      translationKey: 'exampleWeight',
    },
    {
      field: 'image1',
      type: 'String/1000',
      required: true,
      translationKey: 'exampleImage1',
    },
    {
      field: 'image2',
      type: 'String/1000',
      required: false,
      translationKey: 'exampleImage2',
    },
    {
      field: 'image3',
      type: 'String/1000',
      required: false,
      translationKey: 'exampleImage3',
    },
    {
      field: 'image4',
      type: 'String/1000',
      required: false,
      translationKey: 'exampleImage4',
    },
    {
      field: 'image5',
      type: 'String/1000',
      required: false,
      translationKey: 'exampleImage5',
    },
    {
      field: 'image6',
      type: 'String/1000',
      required: false,
      translationKey: 'exampleImage6',
    },
    {
      field: 'width',
      type: 'String/200',
      required: false,
      translationKey: 'exampleWidth',
    },
    {
      field: 'height',
      type: 'String/200',
      required: false,
      translationKey: 'exampleHeight',
    },
    {
      field: 'depth',
      type: 'String/200',
      required: false,
      translationKey: 'exampleDepth',
    },
  ],
  SPECIFIC_LISTING: [
    {
      field: 'ean',
      type: 'String/13',
      required: true,
      shouldBeUniq: true,
      translationKey: 'exampleString13',
    },
    {
      field: 'product_id',
      type: 'Int | UUID',
      required: true,
      shouldBeUniq: true,
      translationKey: 'exampleInt',
    },
  ],
  SPECIFIC_PRODUCT: [
    {
      field: 'ean',
      type: 'String/13',
      required: true,
      translationKey: 'exampleEan',
    },
  ],
}
